<template>
  <v-timeline>
    <v-timeline-item
      v-if="!isFetching"
      align-top
      color="primary"
      icon="fa-solar-panel"
    >
      <span
        slot="opposite"
        class="title"
        v-t="'labels.yesterday'"
      ></span>
      <v-card class="elevation-2  primary white--text">
        <v-card-title class="headline yield  font-weight-medium" >
          {{round(yields.yesterday)}}
          <div class="yield__unit white--text">&nbsp;{{unit}}</div>
        </v-card-title>
      </v-card>
    </v-timeline-item>
    <v-timeline-item
      v-if="!isFetching"
      color="primary"
      icon="fa-solar-panel"
    >
      <i18n
        path="labels.lastXDays"
        tag="span"
        slot="opposite"
        class="subheading"
      >
        <span class="title">7</span>
      </i18n>
      <v-card class="elevation-2  primary white--text">
        <v-card-title class="headline yield  font-weight-medium">
          {{round(yields.sevenDays)}}
          <div class="yield__unit white--text">&nbsp;{{unit}}</div>
        </v-card-title>
      </v-card>
    </v-timeline-item>
    <v-timeline-item
      v-if="!isFetching"
      color="primary"
      icon="fa-solar-panel"
    >
      <span
        slot="opposite"
        class="subheading"
      >{{$t('labels.currentMonth')}}
        <div class="title yield__month">{{month}}</div>
      </span>
      <v-card class="elevation-2 primary white--text">
        <v-card-title class="headline yield  font-weight-medium">
          {{round(yields.month)}}
          <div class="yield__unit white--text">&nbsp;{{unit}}</div>
        </v-card-title>
      </v-card>
    </v-timeline-item>
    <v-timeline-item
      v-if="!isFetching"
      color="primary"
      icon="fa-solar-panel"
    >
      <span
        slot="opposite"
        class="subheading"
      >{{$t('labels.currentYear')}} <div class="title">{{year}}</div></span>
      <v-card class="elevation-2  primary white--text">
        <v-card-title class="headline yield font-weight-medium">
          {{round(yields.year)}}
          <div class="yield__unit white--text">&nbsp;{{unit}}</div>
        </v-card-title>
      </v-card>
    </v-timeline-item>
    <v-timeline-item
      v-if="isFetching"
      color="primary"
      icon="fa-spin fa-spinner"
    >
      <v-card class="elevation-2 primary white--text">
        <v-card-title v-t="'labels.fetchingData'" class="white--text"></v-card-title>
      </v-card>
    </v-timeline-item>
    <v-timeline-item
      style="margin-top: 32px;"
      class="timeline__terminator"
      large
      color="primary"
      icon="fa-sun"
      v-if="$vuetify.breakpoint.mdAndUp"
    >
    </v-timeline-item>
  </v-timeline>
</template>

<script>
import { round, roundCurrency } from '@/helpers/yields';
import moment from 'moment';

export default {
  props: ['yields', 'isFetching', 'view'],

  computed: {
    round() { return this.view === 'yield' ? round : roundCurrency; },

    unit() { return this.view === 'yield' ? 'kWh' : 'EUR'; },

    month: () => moment().format('MMMM'),

    year: () => moment().format('Y'),
  },
};
</script>

<style>
.yield__month {
  text-transform: capitalize;
}
</style>
